var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandMother(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-mothers-day",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-mothers-day:not(.animated) .animable {opacity: 0;}svg#freepik_stories-mothers-day.animated #freepik--background-complete--inject-31 {animation: 6s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31",
    className: "animable",
    style: {
      transformOrigin: "247.982px 254.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.45,445.25c-.93,1.77-1.69,4-.69,5.71a4.55,4.55,0,0,0,4.91,1.76,13.26,13.26,0,0,0,4.85-2.65A16.81,16.81,0,0,0,128,461.4c0,1.39.38,3.07,1.7,3.51a3.61,3.61,0,0,0,2.79-.64,42.7,42.7,0,0,0,9.25-7.06,12.13,12.13,0,0,0,.83,5.59c.85,1.71,2.84,3,4.65,2.42a5.68,5.68,0,0,0,2.42-1.93,41.42,41.42,0,0,0,8.71-17.89c.74-3.48,1-7.23-.42-10.49s-4-6.93-7.49-6.33h1A32,32,0,0,0,123.45,445.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.619px 446.938px"
    },
    id: "eluogwpwjb8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,429.13c.08.06-1.05,1.4-2.64,3.72a53.49,53.49,0,0,0-5.25,9.64,49.64,49.64,0,0,0-3,10.53c-.47,2.78-.57,4.53-.67,4.52a4.92,4.92,0,0,1,0-1.23A29.64,29.64,0,0,1,142,453a43.3,43.3,0,0,1,2.91-10.69,45.42,45.42,0,0,1,5.45-9.65c.84-1.14,1.57-2,2.1-2.62A5,5,0,0,1,153.31,429.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "147.513px 443.335px"
    },
    id: "elnaaz9w3wfpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,441.16a10.08,10.08,0,0,1-1.83,1.66c-1.19,1-2.87,2.22-4.8,3.52s-3.74,2.38-5.07,3.12a10.52,10.52,0,0,1-2.23,1.07c-.08-.15,3.14-2.09,7-4.67S145.71,441,145.81,441.16Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "138.844px 445.841px"
    },
    id: "elc867uffdd4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.92,283.15c-1.1-.42-2.43-.7-3.38,0a2.68,2.68,0,0,0-.68,3,7.85,7.85,0,0,0,1.88,2.64,9.81,9.81,0,0,0-6.91-1.86c-.81.09-1.76.44-1.92,1.24a2.12,2.12,0,0,0,.57,1.57,25,25,0,0,0,4.75,4.89,7.1,7.1,0,0,0-3.19.87A2.44,2.44,0,0,0,26,298.36a3.16,3.16,0,0,0,1.29,1.27,24.1,24.1,0,0,0,11,3.82,10.2,10.2,0,0,0,6.08-1c1.8-1.05,3.75-2.8,3.16-4.8l.07.58A18.74,18.74,0,0,0,35.92,283.15Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "36.272px 293.139px"
    },
    id: "elzvhdemtn3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38,299.4c0,.05-.89-.51-2.35-1.28a31.79,31.79,0,0,0-6-2.38,28.7,28.7,0,0,0-6.35-1c-1.64-.08-2.67,0-2.67-.08a3.83,3.83,0,0,1,.71-.1,17.93,17.93,0,0,1,2-.06,25.57,25.57,0,0,1,6.43.95,27.44,27.44,0,0,1,6,2.49c.72.42,1.29.78,1.67,1A3.3,3.3,0,0,1,47.38,299.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "38.695px 296.949px"
    },
    id: "eli7ks3vfayu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.85,295.88a6.18,6.18,0,0,1-1.09-.95c-.64-.63-1.49-1.52-2.38-2.55s-1.65-2-2.17-2.73a6.81,6.81,0,0,1-.78-1.22c.08-.06,1.43,1.68,3.21,3.73S39.92,295.81,39.85,295.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "36.6412px 292.154px"
    },
    id: "el2eco3ypsjb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,444.87c.87,1.93,1.52,4.31.36,6.07s-3.4,2.08-5.28,1.54a14.07,14.07,0,0,1-4.95-3.1,17.77,17.77,0,0,1,4.07,12.23c-.09,1.47-.6,3.22-2,3.59a3.8,3.8,0,0,1-2.9-.85,44.91,44.91,0,0,1-9.3-8,12.79,12.79,0,0,1-1.23,5.85c-1,1.74-3.19,3-5.06,2.24a5.86,5.86,0,0,1-2.42-2.19,43.59,43.59,0,0,1-8-19.41c-.55-3.72-.58-7.69,1.12-11s4.64-7.05,8.3-6.19l-1.05-.07A33.76,33.76,0,0,1,389.05,444.87Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "371.02px 445.377px"
    },
    id: "el5b7g18km1cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,426c-.08.06,1,1.55,2.55,4.1a56.31,56.31,0,0,1,4.92,10.49,52.88,52.88,0,0,1,2.53,11.3c.32,3,.31,4.81.41,4.81a4.84,4.84,0,0,0,.11-1.3,33.29,33.29,0,0,0-.09-3.54,46,46,0,0,0-2.39-11.47,49.14,49.14,0,0,0-5.12-10.52c-.82-1.25-1.53-2.24-2.06-2.89S358.64,425.93,358.6,426Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "363.864px 441.346px"
    },
    id: "el40yh4bw63w7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.74,439.13a10.9,10.9,0,0,0,1.83,1.87c1.18,1.08,2.88,2.52,4.83,4s3.79,2.75,5.14,3.62a10.55,10.55,0,0,0,2.28,1.27c.1-.15-3.17-2.4-7.05-5.37S365.86,439,365.74,439.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "372.781px 444.508px"
    },
    id: "elfc1qlzegcij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.72,270.23c1.07-.49,2.38-.87,3.36-.23a2.64,2.64,0,0,1,.88,2.92,7.83,7.83,0,0,1-1.69,2.76,9.89,9.89,0,0,1,6.77-2.32c.81,0,1.78.31,2,1.1a2.1,2.1,0,0,1-.46,1.61,24.67,24.67,0,0,1-4.41,5.2,7.18,7.18,0,0,1,3.25.66,2.43,2.43,0,0,1,1.27,2.79,3.34,3.34,0,0,1-1.2,1.36,24.15,24.15,0,0,1-10.73,4.56,10.24,10.24,0,0,1-6.13-.56c-1.87-.93-3.93-2.54-3.48-4.58l0,.59A18.74,18.74,0,0,1,459.72,270.23Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "460.073px 280.268px"
    },
    id: "el04xowiv6kihl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.39,287.22s.85-.57,2.26-1.44a31.81,31.81,0,0,1,5.79-2.78,29.27,29.27,0,0,1,6.26-1.46c1.64-.19,2.67-.2,2.66-.26a3.13,3.13,0,0,0-.72,0,16.38,16.38,0,0,0-2,.07,25.6,25.6,0,0,0-6.35,1.38,27.41,27.41,0,0,0-5.81,2.9,17.81,17.81,0,0,0-1.59,1.16C449.56,287,449.37,287.2,449.39,287.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "457.874px 284.24px"
    },
    id: "el6pqh04206l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.66,283.19a6,6,0,0,0,1-1c.6-.67,1.39-1.61,2.2-2.7s1.51-2.12,2-2.88a5.54,5.54,0,0,0,.69-1.27c-.08-.05-1.31,1.77-2.94,3.94S456.58,283.13,456.66,283.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "459.603px 279.264px"
    },
    id: "elba6107efniw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,176.25a10,10,0,0,0-4-4.49,9.66,9.66,0,0,0-5.65-1.56A7.88,7.88,0,0,0,90.65,173a7.72,7.72,0,0,0-1.59,3.37,7.78,7.78,0,0,0-2.9-1.75,7.88,7.88,0,0,0-6.13.54,9.59,9.59,0,0,0-3.94,4.34,9.93,9.93,0,0,0-1,5.91,12.09,12.09,0,0,0,3.53,6.74,17,17,0,0,0,7.21,3.67c4.36,1.16,10.05,2.54,10.05,2.54s3.23-4.28,6.29-7.59a17.21,17.21,0,0,0,4.14-7A12.11,12.11,0,0,0,105.73,176.25Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "90.8252px 184.276px"
    },
    id: "eluwp971n6kzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,180.48a9.88,9.88,0,0,0-1.07-5.88,9.53,9.53,0,0,0-4-4.26,7.73,7.73,0,0,0-9.25,1.64,7.79,7.79,0,0,0-1.57-3,7.87,7.87,0,0,0-5.53-2.71,9.58,9.58,0,0,0-5.61,1.68,9.92,9.92,0,0,0-3.87,4.56,12.16,12.16,0,0,0-.48,7.6,17.12,17.12,0,0,0,4.28,6.87c3.13,3.25,7.28,7.38,7.28,7.38s5-2,9.32-3.24a17.19,17.19,0,0,0,7.14-3.82A12.11,12.11,0,0,0,422,180.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.153px 180.314px"
    },
    id: "elvkkw97l7m6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,121.82a7,7,0,0,0-1.2-4,6.76,6.76,0,0,0-3.16-2.68A5.46,5.46,0,0,0,54,117a5.45,5.45,0,0,0-5.43-3.45,6.71,6.71,0,0,0-3.81,1.61,7,7,0,0,0-2.37,3.5,8.58,8.58,0,0,0,.26,5.37,12.18,12.18,0,0,0,3.53,4.5c2.45,2,5.69,4.61,5.69,4.61s3.34-1.78,6.28-3a12.11,12.11,0,0,0,4.72-3.23A8.5,8.5,0,0,0,64.69,121.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "53.3845px 123.339px"
    },
    id: "elke1zbmwzv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.66,110.11a7.08,7.08,0,0,0-1.76-3.84,6.79,6.79,0,0,0-3.49-2.22,5.62,5.62,0,0,0-4.28.78,5.53,5.53,0,0,0-1.77,2,5.35,5.35,0,0,0-1.6-1.78,5.53,5.53,0,0,0-4.25-.89,6.78,6.78,0,0,0-3.56,2.12,7.06,7.06,0,0,0-1.85,3.8,8.57,8.57,0,0,0,1,5.28,12.11,12.11,0,0,0,4.12,4c2.71,1.68,6.27,3.79,6.27,3.79s3.07-2.23,5.82-3.84a12,12,0,0,0,4.22-3.85A8.55,8.55,0,0,0,456.66,110.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "445.372px 113.534px"
    },
    id: "eltq8uijmmhlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,456.16a7.08,7.08,0,0,0-1.76-3.84,6.79,6.79,0,0,0-3.49-2.22,5.52,5.52,0,0,0-4.28.78,5.43,5.43,0,0,0-1.77,1.95,5.46,5.46,0,0,0-1.6-1.78,5.58,5.58,0,0,0-4.25-.9,6.74,6.74,0,0,0-3.56,2.13,7,7,0,0,0-1.85,3.79,8.55,8.55,0,0,0,1,5.28,12,12,0,0,0,4.12,4c2.71,1.68,6.27,3.79,6.27,3.79s3.07-2.23,5.81-3.84a12.13,12.13,0,0,0,4.23-3.85A8.55,8.55,0,0,0,219.72,456.16Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "208.429px 459.551px"
    },
    id: "elgndy2cs18v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,57.14a7.1,7.1,0,0,0-1.08-4.08,6.75,6.75,0,0,0-3.08-2.78,5.54,5.54,0,0,0-4.34,0A5.39,5.39,0,0,0,412.45,52a5.6,5.6,0,0,0-1.28-2,5.54,5.54,0,0,0-4-1.59,6.67,6.67,0,0,0-3.86,1.49,7,7,0,0,0-2.48,3.43,8.57,8.57,0,0,0,.09,5.37,12.32,12.32,0,0,0,3.39,4.61c2.39,2.11,5.54,4.78,5.54,4.78s3.4-1.68,6.38-2.79A12.15,12.15,0,0,0,421,62.13,8.59,8.59,0,0,0,423,57.14Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "411.724px 58.2494px"
    },
    id: "elbqp59gs3awk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,45.4a7.18,7.18,0,0,0-3-2.95,6.82,6.82,0,0,0-4.07-.79,5.56,5.56,0,0,0-3.7,2.28,5.41,5.41,0,0,0-.94,2.45A5.44,5.44,0,0,0,84.16,46a6.84,6.84,0,0,0-2.54,3.26,7.08,7.08,0,0,0-.35,4.21,8.6,8.6,0,0,0,2.84,4.57,12.3,12.3,0,0,0,5.28,2.2c3.13.58,7.22,1.25,7.22,1.25s2-3.19,4-5.69a12.09,12.09,0,0,0,2.53-5.12A8.59,8.59,0,0,0,102.33,45.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "92.1773px 51.5516px"
    },
    id: "el5mmzeuq5cqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.26,33.18l1.18,2A13.41,13.41,0,0,0,354,40.24l2,1-1.95,1.18A13.41,13.41,0,0,0,349,48L348,50l-1.18-2A13.41,13.41,0,0,0,341.23,43l-2.05-1,2-1.18a13.41,13.41,0,0,0,5.11-5.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "347.59px 41.59px"
    },
    id: "elujhg2oufiyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,250.82l1.18,2a13.39,13.39,0,0,0,5.54,5.11l2.05,1-2,1.18a13.42,13.42,0,0,0-5.1,5.54l-1,2.05-1.17-2a13.45,13.45,0,0,0-5.55-5.1l-2.05-1,2-1.17a13.47,13.47,0,0,0,5.11-5.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.485px 259.26px"
    },
    id: "el7mp0oo2i0xq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.65,176.45l1.18,2a13.39,13.39,0,0,0,5.55,5.1l2,1-2,1.17a13.47,13.47,0,0,0-5.11,5.55l-1,2.05-1.18-2a13.41,13.41,0,0,0-5.55-5.11l-2-1,2-1.18a13.39,13.39,0,0,0,5.11-5.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "44.96px 184.885px"
    },
    id: "el6q72z5g21dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,459.31l1.17,1.95a13.47,13.47,0,0,0,5.55,5.11l2.05,1-2,1.18a13.41,13.41,0,0,0-5.11,5.55l-1,2.05-1.18-2a13.39,13.39,0,0,0-5.54-5.11l-2.05-1,2-1.18a13.39,13.39,0,0,0,5.1-5.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "292.16px 467.73px"
    },
    id: "elxtca7dlh4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.23,457.54l.56.93a6.33,6.33,0,0,0,2.63,2.42l1,.48-.93.56a6.39,6.39,0,0,0-2.42,2.63l-.48,1-.56-.93a6.39,6.39,0,0,0-2.63-2.42l-1-.48.93-.56a6.39,6.39,0,0,0,2.42-2.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "262.41px 461.55px"
    },
    id: "el15qakeqoztk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05,442l.56.93a6.33,6.33,0,0,0,2.63,2.42l1,.48-.93.56a6.39,6.39,0,0,0-2.42,2.63l-.48,1-.56-.93a6.39,6.39,0,0,0-2.63-2.42l-1-.48.93-.56a6.33,6.33,0,0,0,2.42-2.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "328.23px 446.01px"
    },
    id: "elgjpkoe8tc6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.59,154l.56.93a6.35,6.35,0,0,0,2.63,2.43l1,.48-.93.55A6.39,6.39,0,0,0,68.4,161l-.48,1-.56-.93a6.21,6.21,0,0,0-2.63-2.42l-1-.49.93-.55A6.39,6.39,0,0,0,67.11,155Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "67.755px 158px"
    },
    id: "elq70readbd9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,38l.56.93a6.33,6.33,0,0,0,2.63,2.42l1,.48-.93.56A6.39,6.39,0,0,0,164.26,45l-.48,1-.56-.93a6.39,6.39,0,0,0-2.63-2.42l-1-.48.92-.56A6.35,6.35,0,0,0,163,39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.615px 42px"
    },
    id: "el623eknt2ghs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.8,58.17l.56.93A6.39,6.39,0,0,0,371,61.52l1,.48-.93.56a6.33,6.33,0,0,0-2.42,2.63l-.48,1-.56-.93a6.39,6.39,0,0,0-2.63-2.42l-1-.48.93-.56a6.39,6.39,0,0,0,2.42-2.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "367.99px 62.18px"
    },
    id: "elqpdei05dfrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56,197.44l.55.93a6.39,6.39,0,0,0,2.63,2.42l1,.48-.93.56a6.21,6.21,0,0,0-2.42,2.63l-.49,1-.55-.93a6.39,6.39,0,0,0-2.63-2.42l-1-.48.93-.56a6.35,6.35,0,0,0,2.43-2.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "459.73px 201.45px"
    },
    id: "elgd6rt5s2i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,130.45l.56.93a6.27,6.27,0,0,0,2.63,2.42l1,.48-.93.56a6.39,6.39,0,0,0-2.42,2.63l-.48,1-.56-.92a6.35,6.35,0,0,0-2.63-2.43l-1-.48.93-.55a6.39,6.39,0,0,0,2.42-2.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "419.89px 134.46px"
    },
    id: "elt3wnymiblam",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-31",
    className: "animable",
    style: {
      transformOrigin: "252.396px 323.261px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.48,396.29a34.42,34.42,0,0,0,1.58,21.12c4.89-4.73,10.26-12.44,11.61-19.11a32.92,32.92,0,0,0-1.85-19.66A33.84,33.84,0,0,0,116.48,396.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "122.954px 398.025px"
    },
    id: "elntz454s3x5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.16,407a6,6,0,0,1,0-1.16c.06-.74.18-1.82.36-3.14A83.3,83.3,0,0,1,126,382.57c.51-1.24.95-2.23,1.28-2.9a7.77,7.77,0,0,1,.53-1,5.48,5.48,0,0,1-.39,1.09c-.29.69-.69,1.69-1.16,2.94a100.63,100.63,0,0,0-3.23,9.89c-1.06,3.92-1.77,7.53-2.2,10.16-.21,1.32-.38,2.38-.48,3.12A8.31,8.31,0,0,1,120.16,407Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "123.971px 392.835px"
    },
    id: "el0go0ub145z4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,404.34a34.49,34.49,0,0,0,1.59,21.12c4.89-4.73,10.26-12.44,11.61-19.11a34.21,34.21,0,0,0-2-20A34.48,34.48,0,0,0,86.25,404.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "92.7041px 405.905px"
    },
    id: "el1bckjey6tqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,415a8.36,8.36,0,0,1,.06-1.16c.06-.74.18-1.82.36-3.14a83.54,83.54,0,0,1,5.44-20.12c.51-1.23.95-2.22,1.28-2.89a7.77,7.77,0,0,1,.53-1,6.1,6.1,0,0,1-.4,1.09c-.28.69-.68,1.69-1.15,2.94a103.7,103.7,0,0,0-3.24,9.88c-1,3.93-1.76,7.54-2.19,10.17-.22,1.31-.38,2.38-.48,3.12A6.24,6.24,0,0,1,89.93,415Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "93.7643px 400.845px"
    },
    id: "elo6qkpj7kwc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,384.84a34.56,34.56,0,0,1-12.57-17c6.8.4,15.9,2.75,21.27,6.92a34.16,34.16,0,0,1,11.5,16.5A34.56,34.56,0,0,1,67,384.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "70.815px 379.55px"
    },
    id: "elhbnrlaxwdfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.83,374.33a7.53,7.53,0,0,0,.8.84c.53.53,1.32,1.27,2.32,2.15a83.05,83.05,0,0,0,8.26,6.4,85.44,85.44,0,0,0,9,5.31c1.2.6,2.17,1.06,2.86,1.36a5.91,5.91,0,0,0,1.08.43,7.41,7.41,0,0,0-1-.56c-.66-.34-1.62-.84-2.79-1.48a101.38,101.38,0,0,1-8.89-5.39,103,103,0,0,1-8.3-6.27c-1-.86-1.83-1.56-2.39-2.06A6.51,6.51,0,0,0,62.83,374.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.99px 382.575px"
    },
    id: "elt16glbweu2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,374.78a34.43,34.43,0,0,1-12.57-17c6.8.39,15.9,2.74,21.27,6.92a34.18,34.18,0,0,1,11.5,16.49A34.41,34.41,0,0,1,96,374.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "99.815px 369.485px"
    },
    id: "ele1gpmaaw44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.84,364.28a7.53,7.53,0,0,0,.8.84c.53.53,1.32,1.26,2.32,2.15A83.94,83.94,0,0,0,112.2,379c1.2.61,2.17,1.07,2.86,1.37a7,7,0,0,0,1.08.43,5.76,5.76,0,0,0-1-.57c-.66-.34-1.62-.84-2.79-1.47-2.34-1.26-5.53-3.11-8.9-5.39a101.84,101.84,0,0,1-8.29-6.28c-1-.85-1.84-1.56-2.4-2.05A6.18,6.18,0,0,0,91.84,364.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.99px 372.54px"
    },
    id: "elwcacq8h0au",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,378.46a5.5,5.5,0,0,1-.88,0l-2.52-.07-1.82-.07c-.66,0-1.38,0-2.16,0-1.55,0-3.31,0-5.26.11l-3.06.15c-1.07.06-2.17.19-3.31.29-2.29.17-4.71.55-7.27.9a133.41,133.41,0,0,0-16.35,3.7,133.57,133.57,0,0,0-15.69,5.93c-2.32,1.11-4.55,2.14-6.55,3.26-1,.55-2,1-2.92,1.58l-2.64,1.56c-1.7,1-3.15,2-4.45,2.81-.65.43-1.26.81-1.81,1.18l-1.48,1.06L69,402.32a5,5,0,0,1-.74.48,5.29,5.29,0,0,1,.68-.56l2-1.53,1.46-1.1c.54-.39,1.14-.78,1.78-1.22,1.3-.86,2.74-1.9,4.43-2.88l2.63-1.6c.91-.55,1.9-1.05,2.91-1.61,2-1.14,4.23-2.18,6.56-3.32a118.55,118.55,0,0,1,32.17-9.67c2.57-.34,5-.7,7.3-.85,1.15-.09,2.26-.21,3.32-.26l3.07-.12c2-.11,3.73,0,5.29,0,.77,0,1.5,0,2.16,0l1.82.12,2.51.17A6.79,6.79,0,0,1,149.26,378.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.76px 390.416px"
    },
    id: "elvg8vi8vb84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.42,403.61A34.47,34.47,0,0,0,44.31,421c6.78-.58,15.82-3.18,21.08-7.5a34.2,34.2,0,0,0,11-16.79A34.41,34.41,0,0,0,56.42,403.61Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "60.35px 408.855px"
    },
    id: "el3zmrkxan8ts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,414.22a8,8,0,0,1,.78-.86c.51-.54,1.29-1.3,2.26-2.21A84.11,84.11,0,0,1,72.48,399c1.18-.63,2.14-1.12,2.82-1.44a7,7,0,0,1,1.06-.46,5.29,5.29,0,0,1-1,.6c-.66.35-1.6.88-2.75,1.54a103.82,103.82,0,0,0-8.75,5.63,102,102,0,0,0-8.12,6.5c-1,.88-1.8,1.61-2.34,2.12A6.23,6.23,0,0,1,52.52,414.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "64.44px 405.66px"
    },
    id: "el6ih14dnb13e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,304.65a39.36,39.36,0,0,0-24,3.54c5.8,5.2,15.05,10.69,22.77,11.68a39.13,39.13,0,0,0,22.66-4A39.38,39.38,0,0,0,82.4,304.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "81.115px 312.136px"
    },
    id: "el6uj8yvpf8xd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,309.73a7,7,0,0,1,1.33,0c.86,0,2.09.06,3.62.16a94.77,94.77,0,0,1,11.84,1.54,97.37,97.37,0,0,1,11.56,3c1.46.48,2.62.9,3.41,1.22a6.89,6.89,0,0,1,1.22.53,8.21,8.21,0,0,1-1.27-.37c-.81-.26-2-.64-3.45-1.08-2.92-.88-7-2-11.55-2.87a117.24,117.24,0,0,0-11.79-1.67c-1.51-.14-2.75-.24-3.6-.29A7.58,7.58,0,0,1,70.5,309.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.99px 312.939px"
    },
    id: "elwq0ychzxy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,339.64a34.51,34.51,0,0,0-19.38,8.53c6.09,3,15.15,5.53,21.89,4.58a34.11,34.11,0,0,0,18.18-8.58A34.47,34.47,0,0,0,102.81,339.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "103.465px 346.216px"
    },
    id: "elkewjabs5jw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,346.67a7.6,7.6,0,0,1,1.11-.33c.72-.19,1.78-.44,3.09-.71a84.2,84.2,0,0,1,20.77-1.57c1.34.07,2.42.16,3.16.24a6.63,6.63,0,0,1,1.15.16,6.46,6.46,0,0,1-1.16,0c-.75,0-1.82-.08-3.16-.11a102.77,102.77,0,0,0-10.4.24c-4,.31-7.69.85-10.31,1.32-1.31.24-2.37.44-3.1.59A6.32,6.32,0,0,1,94,346.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.64px 345.315px"
    },
    id: "elrr966pzgzgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,311.28a34.46,34.46,0,0,1,9.17-19.1c2.83,6.19,5,15.33,3.85,22a34.11,34.11,0,0,1-9.17,17.89A34.46,34.46,0,0,1,110,311.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "116.525px 312.125px"
    },
    id: "elv6ij4atnao9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.33,302.66a7.93,7.93,0,0,0-.37,1.1c-.21.71-.49,1.76-.81,3.06a84.52,84.52,0,0,0-1.77,10.28,82.65,82.65,0,0,0-.48,10.43c0,1.34.07,2.42.13,3.16a6.51,6.51,0,0,0,.13,1.16,8.11,8.11,0,0,0,0-1.16c0-.75,0-1.83,0-3.16,0-2.66.16-6.34.59-10.38s1.1-7.67,1.66-10.27c.28-1.3.52-2.36.69-3.08A5.78,5.78,0,0,0,117.33,302.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.609px 317.255px"
    },
    id: "elb61g547pykl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.09,283.48a33.62,33.62,0,0,1,13.49-15.7c1.1,6.55.85,15.73-2,21.76A33.34,33.34,0,0,1,96.45,304.1,33.65,33.65,0,0,1,98.09,283.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "103.863px 285.94px"
    },
    id: "elhf76kshq0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,277.2a6.65,6.65,0,0,0-.63.94c-.38.62-.91,1.54-1.53,2.68a80.23,80.23,0,0,0-4.29,9.26,81.61,81.61,0,0,0-3.09,9.72c-.31,1.27-.54,2.3-.67,3a5.87,5.87,0,0,0-.18,1.12,5.94,5.94,0,0,0,.32-1.09c.18-.71.44-1.73.79-3a100.72,100.72,0,0,1,3.19-9.65c1.44-3.7,3-7,4.16-9.27.59-1.16,1.09-2.09,1.43-2.73A5.51,5.51,0,0,0,107.18,277.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.985px 290.56px"
    },
    id: "elef9r3hy0hmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,381.52a1.18,1.18,0,0,1-.27-.18l-.78-.57-2.95-2.24-2.13-1.62-2.46-2c-1.75-1.47-3.79-3.09-5.91-5-1.08-1-2.2-2-3.37-3s-2.32-2.21-3.55-3.38c-2.48-2.3-5-4.94-7.61-7.66a236.57,236.57,0,0,1-15.92-18.95,221.5,221.5,0,0,1-13.57-20.7c-1.82-3.34-3.62-6.48-5.06-9.55-.74-1.52-1.49-3-2.15-4.39s-1.24-2.82-1.83-4.14c-1.2-2.61-2.09-5.06-2.92-7.19l-1.14-3q-.46-1.4-.84-2.55c-.49-1.5-.88-2.68-1.15-3.52-.12-.38-.22-.68-.29-.92a1.46,1.46,0,0,1-.08-.31,1.38,1.38,0,0,1,.13.3l.34.9c.29.83.71,2,1.24,3.49.26.76.56,1.6.88,2.52s.76,1.9,1.18,3c.86,2.11,1.76,4.55,3,7.14L96.32,302c.67,1.42,1.43,2.87,2.17,4.38,1.46,3.05,3.27,6.17,5.1,9.5a227.73,227.73,0,0,0,13.57,20.63A243.57,243.57,0,0,0,133,355.48c2.64,2.73,5.1,5.37,7.56,7.68,1.22,1.17,2.37,2.33,3.52,3.39l3.34,3c2.1,2,4.12,3.6,5.86,5.08l2.43,2,2.09,1.67,2.9,2.31.74.61C161.62,381.44,161.7,381.51,161.69,381.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.7px 331.085px"
    },
    id: "el68lpy3zbkz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,235.52c-1.36-2.78-3.42-5.72-6.5-6.05-2.84-.31-5.48,1.89-6.63,4.51s-1.15,5.59-1.12,8.45a25.86,25.86,0,0,0-10-16c-1.73-1.28-4.17-2.32-5.92-1.07-1.23.88-1.55,2.55-1.73,4.05a65.74,65.74,0,0,0,.39,17.94c-2.35-1.76-4.82-3.57-7.72-4.06s-6.32.81-7.23,3.6a8.72,8.72,0,0,0,.21,4.77A63.59,63.59,0,0,0,65,278.8c3.66,4.08,8.1,7.8,13.45,9s12.25,1.33,14.68-3.58l-.89,1.25A49.31,49.31,0,0,0,96.84,235.52Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "75.8588px 256.647px"
    },
    id: "elbq21r3akoqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,287.35a2.62,2.62,0,0,1-.16-.47l-.39-1.34c-.15-.59-.35-1.31-.62-2.13s-.53-1.77-.91-2.79-.75-2.16-1.23-3.34-1-2.44-1.59-3.76a84.57,84.57,0,0,0-4.36-8.26,79.53,79.53,0,0,0-5.37-7.65c-.92-1.11-1.77-2.18-2.64-3.11s-1.67-1.82-2.44-2.59-1.48-1.45-2.1-2-1.18-1.09-1.64-1.49l-1-.93a2.35,2.35,0,0,1-.34-.35,2.09,2.09,0,0,1,.4.28l1.1.87c.48.38,1,.86,1.69,1.45s1.39,1.22,2.15,2,1.63,1.61,2.49,2.57,1.75,2,2.68,3.09A76.79,76.79,0,0,1,80.88,265a78.32,78.32,0,0,1,4.37,8.32c.56,1.33,1.12,2.58,1.55,3.79s.85,2.33,1.19,3.37.61,2,.85,2.82.43,1.56.56,2.15.23,1,.31,1.37A1.63,1.63,0,0,1,89.79,287.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.3951px 267.245px"
    },
    id: "eljubv57w78lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.62,267.07a4.41,4.41,0,0,1-.11-1c-.05-.66-.09-1.61-.13-2.78-.07-2.34-.09-5.58.05-9.16s.4-6.81.65-9.14c.13-1.16.24-2.1.34-2.75a4.48,4.48,0,0,1,.19-1,5.29,5.29,0,0,1,0,1c0,.74-.12,1.67-.2,2.77-.18,2.33-.39,5.56-.53,9.13s-.16,6.8-.17,9.14c0,1.1,0,2,0,2.77A5.11,5.11,0,0,1,81.62,267.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.9798px 254.155px"
    },
    id: "elxwz5z1pxbke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpb9xzt7agbq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "73.25px 256.64px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.36,247.4S79,253,81.14,265.88C81.14,265.88,74.17,253.86,65.36,247.4Z",
    id: "el0zgyati5tiz",
    className: "animable",
    style: {
      transformOrigin: "73.25px 256.64px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M52.71,322.56c-2-.74-4.37-1.24-6.05,0s-1.84,3.5-1.19,5.34a14.06,14.06,0,0,0,3.4,4.72,17.64,17.64,0,0,0-12.42-3.25c-1.45.17-3.15.79-3.44,2.23a3.82,3.82,0,0,0,1,2.83,44.63,44.63,0,0,0,8.59,8.72,12.77,12.77,0,0,0-5.73,1.6c-1.67,1.12-2.76,3.36-1.91,5.18a6,6,0,0,0,2.33,2.26A43.34,43.34,0,0,0,57.15,359c3.73.31,7.67.09,10.89-1.82s6.71-5.07,5.62-8.65l.14,1A33.62,33.62,0,0,0,52.71,322.56Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "53.4329px 340.461px"
    },
    id: "elq8r8zh9woeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,351.6a1.26,1.26,0,0,1-.3-.15l-.82-.49c-.35-.22-.79-.48-1.31-.76s-1.09-.64-1.75-1-1.38-.72-2.18-1.08-1.64-.74-2.54-1.12a54.56,54.56,0,0,0-6-2.06,55.63,55.63,0,0,0-6.24-1.29c-1-.12-1.9-.25-2.77-.31s-1.68-.12-2.42-.15-1.42,0-2,0-1.09,0-1.51,0l-1,0a1,1,0,0,1-.33,0l.33,0,1-.08c.42,0,.93-.07,1.52-.08s1.27,0,2,0,1.56,0,2.44.11,1.8.17,2.78.29a51.94,51.94,0,0,1,6.29,1.27,54.83,54.83,0,0,1,6.06,2.09c.9.4,1.76.76,2.55,1.16s1.51.76,2.16,1.12,1.23.7,1.75,1,.93.57,1.28.8l.8.54C73.39,351.53,73.48,351.59,73.47,351.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "57.8854px 347.313px"
    },
    id: "elzk13wp8d2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.92,345.36a4.26,4.26,0,0,1-.53-.45c-.33-.31-.79-.76-1.36-1.32-1.13-1.14-2.66-2.74-4.26-4.58s-3-3.57-4-4.84c-.48-.64-.86-1.16-1.12-1.53a2.53,2.53,0,0,1-.37-.58,3,3,0,0,1,.46.51L50,334c1,1.24,2.41,2.95,4,4.78s3.1,3.46,4.2,4.62l1.29,1.39C59.77,345.15,59.94,345.34,59.92,345.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "54.1008px 338.71px"
    },
    id: "elid9bqggiaaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnx0ej3ffhcr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "50.885px 343.502px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.64,343.19s9.42-3.6,16.49,1.8C59.13,345,50,342.28,42.64,343.19Z",
    id: "el1nxl8ekia79",
    className: "animable",
    style: {
      transformOrigin: "50.885px 343.502px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.11,392.13a34.44,34.44,0,0,1-.14,21.18c-5.2-4.39-11.08-11.72-12.88-18.28a32.91,32.91,0,0,1,.5-19.74A33.77,33.77,0,0,1,398.11,392.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.762px 394.3px"
    },
    id: "el8fvhwlzw2ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.17,403.05a6.09,6.09,0,0,0-.13-1.16c-.11-.74-.31-1.8-.58-3.11a83.27,83.27,0,0,0-6.8-19.7c-.59-1.19-1.09-2.15-1.46-2.8a7.2,7.2,0,0,0-.61-1,8,8,0,0,0,.47,1.06c.33.67.8,1.64,1.36,2.85a102.45,102.45,0,0,1,6.78,19.64c.3,1.3.53,2.35.69,3.08A5.94,5.94,0,0,0,395.17,403.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.38px 389.165px"
    },
    id: "el8z0k60wfio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,398.1a34.44,34.44,0,0,1-.14,21.18c-5.2-4.39-11.08-11.72-12.88-18.28a34.11,34.11,0,0,1,.66-20.1A34.49,34.49,0,0,1,428.81,398.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "422.498px 400.09px"
    },
    id: "elp4cu9g4ypxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,409a5.74,5.74,0,0,0-.14-1.16c-.1-.74-.3-1.8-.57-3.11a83.94,83.94,0,0,0-2.78-10.06,82.28,82.28,0,0,0-4-9.63c-.59-1.2-1.09-2.16-1.47-2.81a6.72,6.72,0,0,0-.6-1,7.36,7.36,0,0,0,.47,1.06c.33.67.8,1.65,1.36,2.85a103.49,103.49,0,0,1,3.89,9.65,100.48,100.48,0,0,1,2.88,10c.31,1.3.54,2.35.7,3.08A5.94,5.94,0,0,0,425.87,409Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.09px 395.115px"
    },
    id: "el9clbkgfmwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.68,377.33a34.45,34.45,0,0,0,11.38-17.86c-6.75.86-15.67,3.82-20.74,8.36A34.13,34.13,0,0,0,427,385.06,34.44,34.44,0,0,0,446.68,377.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "442.53px 372.265px"
    },
    id: "el2ltbb2y3iz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.14,366.57a7.34,7.34,0,0,1-.74.89c-.49.57-1.23,1.35-2.17,2.31a84.14,84.14,0,0,1-7.8,6.93,82.65,82.65,0,0,1-8.61,5.91c-1.14.69-2.09,1.22-2.75,1.56a5.14,5.14,0,0,1-1.05.5,9,9,0,0,1,1-.63c.64-.38,1.56-1,2.69-1.66,2.25-1.42,5.31-3.48,8.51-6a102.06,102.06,0,0,0,7.84-6.83c1-.92,1.73-1.68,2.26-2.21A6.2,6.2,0,0,1,450.14,366.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "438.58px 375.62px"
    },
    id: "elg4d5d2pd7bc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.05,369.28a34.42,34.42,0,0,0,11.38-17.87c-6.75.86-15.66,3.83-20.74,8.36A34,34,0,0,0,397.34,377,34.43,34.43,0,0,0,417.05,369.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "412.885px 364.205px"
    },
    id: "ela1wv8z124r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.51,358.51a5.94,5.94,0,0,1-.74.9c-.49.56-1.23,1.35-2.17,2.3a84.19,84.19,0,0,1-7.8,6.94,85.93,85.93,0,0,1-8.6,5.91c-1.15.68-2.09,1.21-2.76,1.55a7.46,7.46,0,0,1-1,.51,5.5,5.5,0,0,1,1-.64c.64-.38,1.56-1,2.68-1.66a99.33,99.33,0,0,0,8.51-6c3.2-2.51,5.93-5,7.85-6.83,1-.92,1.73-1.68,2.25-2.21A7.17,7.17,0,0,1,420.51,358.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.975px 367.565px"
    },
    id: "elxesxqoxn2qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.2,376.57a4.71,4.71,0,0,1,.86-.15l2.5-.35,1.8-.23c.67-.07,1.39-.12,2.16-.18,1.55-.12,3.32-.31,5.27-.33l3.08-.09c1.06,0,2.18,0,3.33,0,2.3,0,4.75.19,7.34.36a117.67,117.67,0,0,1,32.75,7.45c2.4,1,4.7,1.86,6.77,2.87,1,.48,2.07.92,3,1.41l2.73,1.41c1.76.87,3.26,1.8,4.61,2.57.67.4,1.3.75,1.87,1.1l1.52,1c.89.58,1.59,1,2.1,1.39a6.51,6.51,0,0,1,.72.51,4.36,4.36,0,0,1-.77-.43l-2.15-1.3-1.55-1c-.57-.33-1.21-.67-1.88-1.06-1.36-.74-2.88-1.65-4.64-2.5l-2.74-1.37c-.95-.48-2-.9-3-1.38-2.07-1-4.36-1.85-6.76-2.81a121.45,121.45,0,0,0-32.62-7.42c-2.57-.18-5-.39-7.31-.4-1.15,0-2.26-.08-3.32-.07l-3.06.06c-2,0-3.72.16-5.27.25-.77.05-1.49.08-2.15.13l-1.81.2-2.5.24A5.29,5.29,0,0,1,364.2,376.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.405px 385.275px"
    },
    id: "eli43nmm9zix9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.53,395.34a34.45,34.45,0,0,1,13.26,16.51c-6.8-.11-16-2.09-21.53-6a34.18,34.18,0,0,1-12.18-16A34.42,34.42,0,0,1,458.53,395.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "454.935px 400.828px"
    },
    id: "elkdlxxp4ujq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.14,405.66a6.56,6.56,0,0,0-.84-.8c-.55-.51-1.37-1.21-2.4-2.06a83.92,83.92,0,0,0-17.71-11c-1.22-.55-2.21-1-2.91-1.25a5.76,5.76,0,0,0-1.09-.38,7.2,7.2,0,0,0,1,.52c.68.31,1.65.77,2.85,1.36A101.29,101.29,0,0,1,459.73,403c1,.81,1.9,1.48,2.48,2A5.76,5.76,0,0,0,463.14,405.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "450.665px 397.915px"
    },
    id: "elm4w45enjk6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.13,299.82a38.47,38.47,0,0,1,23.61,1.46c-5.21,5.53-13.75,11.63-21.17,13.24a38.1,38.1,0,0,1-22.36-2A38.43,38.43,0,0,1,413.13,299.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "414.975px 306.986px"
    },
    id: "el93hbjr7mt5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.12,303.77a7.31,7.31,0,0,0-1.29.08c-.83.08-2,.23-3.5.45A92.72,92.72,0,0,0,398,310.67c-1.37.59-2.47,1.09-3.21,1.46a6.23,6.23,0,0,0-1.14.62,9,9,0,0,0,1.21-.46c.76-.33,1.88-.79,3.26-1.34a114.9,114.9,0,0,1,11-3.75c4.36-1.24,8.39-2.08,11.32-2.6,1.46-.26,2.65-.46,3.47-.58A6.9,6.9,0,0,0,425.12,303.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.385px 308.259px"
    },
    id: "elf63v03het4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58,329.67a33.57,33.57,0,0,1,19.55,6.69c-5.66,3.45-14.27,6.62-20.9,6.26a33.3,33.3,0,0,1-18.38-6.83A33.62,33.62,0,0,1,400.58,329.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "400.49px 336.158px"
    },
    id: "eltp8qjb81wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,335.77a8.09,8.09,0,0,0-1.11-.23c-.71-.13-1.76-.28-3.05-.43a81.68,81.68,0,0,0-20.33.19c-1.29.18-2.33.35-3,.5a6.23,6.23,0,0,0-1.1.25,5.6,5.6,0,0,0,1.13-.11c.72-.1,1.76-.23,3.05-.37,2.58-.29,6.17-.58,10.13-.62a100.94,100.94,0,0,1,10.14.42c1.29.12,2.34.23,3.06.32A5.63,5.63,0,0,0,409.77,335.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.475px 335.308px"
    },
    id: "el45q0zeraa68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,308.56a33.63,33.63,0,0,0-10.49-17.81c-2.24,6.25-3.61,15.32-1.92,21.74a33.29,33.29,0,0,0,10.4,16.63A33.59,33.59,0,0,0,386.84,308.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "380.645px 309.935px"
    },
    id: "el7n05kqm8bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,300.78a6.1,6.1,0,0,1,.45,1c.28.68.63,1.67,1.05,2.91a83.37,83.37,0,0,1,2.58,9.85,80.59,80.59,0,0,1,1.32,10.1c.09,1.3.13,2.35.14,3.08a6.8,6.8,0,0,1,0,1.14,5.8,5.8,0,0,1-.12-1.13c0-.73-.13-1.77-.25-3.07-.24-2.59-.68-6.15-1.44-10.05a100,100,0,0,0-2.46-9.84c-.38-1.24-.7-2.25-.92-2.94A6.89,6.89,0,0,1,379,300.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.782px 314.82px"
    },
    id: "elqy1mgi2do1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.13,280.54a32.82,32.82,0,0,0-14.41-14.14c-.54,6.46.47,15.37,3.69,21a32.54,32.54,0,0,0,14,13.06A32.87,32.87,0,0,0,396.13,280.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "390.678px 283.43px"
    },
    id: "elrsyjsh3ukh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.77,275.19a8.1,8.1,0,0,1,.69.87c.43.57,1,1.41,1.72,2.48a79.31,79.31,0,0,1,8.74,17.83c.41,1.21.72,2.19.91,2.88a7.13,7.13,0,0,1,.26,1.07,5.27,5.27,0,0,1-.4-1c-.23-.67-.58-1.64-1-2.83a97.79,97.79,0,0,0-3.89-9.12c-1.71-3.47-3.48-6.51-4.82-8.66-.67-1.08-1.23-1.95-1.62-2.54A5.94,5.94,0,0,1,386.77,275.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.93px 287.755px"
    },
    id: "elthbxifvhwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.43,381.12l.22-.23.67-.66,2.62-2.49,1.9-1.79,2.19-2.19c1.57-1.59,3.39-3.35,5.27-5.43l3-3.22c1-1.13,2.05-2.35,3.14-3.59,2.2-2.45,4.37-5.22,6.71-8.1A238.46,238.46,0,0,0,382,333.71a224.38,224.38,0,0,0,11.48-21.18c1.5-3.38,3-6.57,4.16-9.65.61-1.53,1.22-3,1.75-4.44s1-2.82,1.46-4.14c1-2.63,1.66-5.08,2.32-7.2q.48-1.61.9-3c.23-.92.45-1.76.65-2.53.39-1.49.7-2.66.92-3.49.1-.37.19-.67.25-.9a1.59,1.59,0,0,1,.1-.31,1.55,1.55,0,0,1-.05.32c-.05.23-.12.53-.2.92-.2.83-.47,2-.82,3.51-.19.77-.39,1.62-.61,2.54s-.55,1.92-.86,3c-.64,2.14-1.29,4.59-2.25,7.23-.46,1.33-.93,2.72-1.43,4.17S398.63,301.5,398,303c-1.14,3.1-2.64,6.3-4.13,9.7A214.88,214.88,0,0,1,382.43,334a226.85,226.85,0,0,1-13.91,19.74c-2.35,2.87-4.54,5.64-6.76,8.09-1.09,1.23-2.13,2.45-3.17,3.57l-3,3.2c-1.9,2.07-3.75,3.82-5.33,5.38L348,376.13l-1.93,1.76-2.69,2.42-.7.62C342.52,381.06,342.44,381.13,342.43,381.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.21px 328.995px"
    },
    id: "elwonq9uzqrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,233.82c1.09-2.81,2.85-5.84,5.81-6.42,2.74-.54,5.49,1.38,6.83,3.84s1.57,5.33,1.78,8.12A25.27,25.27,0,0,1,416.17,223c1.57-1.38,3.86-2.6,5.66-1.53,1.27.76,1.72,2.35,2,3.8A64,64,0,0,1,425,242.76c2.14-1.91,4.4-3.87,7.17-4.58s6.21.26,7.33,2.9a8.48,8.48,0,0,1,.19,4.64,62,62,0,0,1-11.71,27.53c-3.22,4.27-7.23,8.26-12.33,9.87s-11.8,2.32-14.57-2.26l1,1.14A48.09,48.09,0,0,1,393.37,233.82Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "415.147px 252.705px"
    },
    id: "elaje5upaus4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.52,283.62a3.23,3.23,0,0,0,.12-.47c.06-.35.15-.79.26-1.34s.24-1.3.43-2.12.37-1.77.65-2.79.55-2.15.92-3.34.78-2.46,1.23-3.79a83.59,83.59,0,0,1,3.56-8.39,80.1,80.1,0,0,1,4.58-7.88c.8-1.16,1.54-2.26,2.31-3.25s1.48-1.9,2.16-2.72,1.32-1.53,1.87-2.16,1.06-1.16,1.47-1.59l.94-1a2.19,2.19,0,0,0,.31-.37,2.19,2.19,0,0,0-.37.31l-1,.94c-.44.41-1,.92-1.53,1.54s-1.25,1.31-1.92,2.14-1.46,1.69-2.21,2.7-1.54,2.08-2.35,3.23a69.57,69.57,0,0,0-8.18,16.36c-.45,1.34-.88,2.61-1.2,3.82s-.64,2.34-.88,3.37-.43,2-.59,2.81-.29,1.55-.37,2.14-.14,1-.19,1.36A1.93,1.93,0,0,0,404.52,283.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.921px 263.015px"
    },
    id: "elen78zernm3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,263.23a4.11,4.11,0,0,0,0-1c0-.64,0-1.56-.1-2.7-.13-2.29-.38-5.44-.81-8.9s-1-6.59-1.39-8.83c-.22-1.13-.41-2-.56-2.66a4.9,4.9,0,0,0-.26-.95,4.31,4.31,0,0,0,.11,1q.16,1.06.42,2.67c.36,2.25.84,5.37,1.27,8.83s.73,6.59.93,8.87c.09,1.07.17,2,.23,2.69A5.15,5.15,0,0,0,410.78,263.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.235px 250.71px"
    },
    id: "elw2dhc557xe8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el13jwiw9tj9k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "418.095px 252.395px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425,242.76s-12.81,6.6-13.81,19.27C411.14,262,416.92,249.77,425,242.76Z",
    id: "eloswxgpl5qcb",
    className: "animable",
    style: {
      transformOrigin: "418.095px 252.395px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,310.41c1.92-.88,4.27-1.54,6-.38s2.08,3.37,1.55,5.25a14,14,0,0,1-3.07,4.94,17.67,17.67,0,0,1,12.17-4.09c1.46.08,3.2.58,3.58,2a3.78,3.78,0,0,1-.84,2.89,45.09,45.09,0,0,1-8,9.29,12.82,12.82,0,0,1,5.83,1.2c1.74,1,3,3.17,2.25,5a5.9,5.9,0,0,1-2.17,2.43A43.39,43.39,0,0,1,446.88,347c-3.7.56-7.65.6-11-1.08s-7-4.6-6.2-8.25l-.07,1.05A33.65,33.65,0,0,1,448.83,310.41Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "449.329px 328.378px"
    },
    id: "eld1u7ymcaurs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.09,340.8l.29-.18.79-.54c.34-.24.75-.54,1.25-.85s1.05-.71,1.69-1.08,1.32-.82,2.09-1.23,1.59-.85,2.47-1.3a56.65,56.65,0,0,1,5.88-2.46,52.29,52.29,0,0,1,6.14-1.71c1-.19,1.88-.38,2.74-.5s1.67-.23,2.41-.31,1.41-.12,2-.17,1.1-.07,1.51-.07l1,0,.34,0a1.3,1.3,0,0,0-.34,0l-1,0c-.41,0-.92,0-1.51,0s-1.27.05-2,.13-1.56.14-2.42.28-1.79.29-2.76.47a48.34,48.34,0,0,0-12.09,4.2c-.88.45-1.71.87-2.46,1.32s-1.46.86-2.09,1.26-1.18.79-1.67,1.12-.9.64-1.23.9l-.76.58A1.55,1.55,0,0,0,430.09,340.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "445.39px 335.594px"
    },
    id: "eluk89vno5lpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.19,333.64a3.49,3.49,0,0,0,.49-.49c.31-.32.75-.8,1.27-1.4,1.05-1.21,2.47-2.91,3.94-4.86s2.74-3.76,3.62-5.1c.44-.67.78-1.22,1-1.6a2.83,2.83,0,0,0,.33-.61,3.26,3.26,0,0,0-.43.55l-1.09,1.55c-.92,1.3-2.2,3.1-3.67,5s-2.86,3.66-3.87,4.89l-1.2,1.47A3,3,0,0,0,443.19,333.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "448.515px 326.61px"
    },
    id: "elib840imaonr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbe6kl0cjrfu"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "452.115px 331.394px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.28,330.31s-9.64-2.95-16.33,2.91C444,333.22,452.84,329.9,460.28,330.31Z",
    id: "eljfllp0hrdrp",
    className: "animable",
    style: {
      transformOrigin: "452.115px 331.394px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-31",
    className: "animable animator-active animator-hidden",
    style: {
      transformOrigin: "237.46px 105.49px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.57,127.77,145.79,105.3l-31.06-1.79v1.79L83.67,132.79h27.49l-8.58,30.7S149.72,130.25,162.57,127.77Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "123.12px 133.5px"
    },
    id: "el5d5zr626m7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,132.79,360.19,105.3v-1.79l-31.06,1.79-16.78,22.47c12.85,2.48,60,35.72,60,35.72l-8.58-30.7Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "351.8px 133.5px"
    },
    id: "el2k6phzyj4ew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,92.38S154.7,47.49,239.2,47.49c87.13,0,136.61,48.11,136.61,48.11l-28.22,42.19s-38.07-33.27-108.39-33.46c-64.31-.18-109.42,30.77-109.42,30.77Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "239.195px 92.64px"
    },
    id: "el5u6hndwijbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,92.38a3.2,3.2,0,0,1,.53.68c.36.55.81,1.22,1.36,2l4.87,7.59c4.09,6.42,9.69,15.33,15.83,25.19,1.38,2.24,2.74,4.43,4,6.53l-.43-.19,24.07-4.75,7.11-1.32,1.92-.32a2.87,2.87,0,0,1,.68-.06,2.16,2.16,0,0,1-.65.21l-1.89.46L153,130l-24,5-.28.05-.15-.24-4.07-6.52c-6.14-9.87-11.65-18.82-15.61-25.33l-4.65-7.72c-.49-.86-.9-1.56-1.23-2.13A3.65,3.65,0,0,1,102.58,92.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.55px 113.715px"
    },
    id: "eljxxxza27xbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07,115.36a8.38,8.38,0,0,1-1.7.72l-4.67,1.86c-3.94,1.59-9.36,3.85-15.32,6.38l-15.25,6.55-4.63,2a8.18,8.18,0,0,1-1.73.64,7.92,7.92,0,0,1,1.59-.94c1.06-.55,2.6-1.32,4.52-2.23,3.84-1.83,9.19-4.25,15.17-6.79s11.43-4.7,15.43-6.16c2-.73,3.64-1.27,4.78-1.61A7.45,7.45,0,0,1,172.07,115.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.42px 124.435px"
    },
    id: "eln5udnjil0aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.81,95.6a3.53,3.53,0,0,1-.41.76l-1.32,2.1-5,7.61c-4.22,6.42-10.11,15.24-16.65,25l-2.59,3.83-.15.23-.27-.05L323,130l-7.84-1.58-2.12-.46a2.69,2.69,0,0,1-.72-.22,3.5,3.5,0,0,1,.75.06l2.14.32,7.9,1.33,26.46,4.74-.42.18,2.58-3.84c6.54-9.72,12.51-18.49,16.86-24.82l5.19-7.46c.58-.81,1.06-1.48,1.45-2A3.76,3.76,0,0,1,375.81,95.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.065px 115.365px"
    },
    id: "elkslslqc6j5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,115.36a7.35,7.35,0,0,1,1.81.41c1.14.34,2.78.88,4.78,1.61,4,1.46,9.46,3.63,15.43,6.16s11.33,5,15.17,6.79c1.92.91,3.46,1.68,4.52,2.23a7.92,7.92,0,0,1,1.59.94,8.18,8.18,0,0,1-1.73-.64l-4.62-2L328,124.32c-6-2.53-11.38-4.79-15.31-6.38L308,116.08A8.33,8.33,0,0,1,306.32,115.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.97px 124.43px"
    },
    id: "elgzyrsfwxdmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,93.81l6.19,11.42-1.1.59-2.85-5.27-6.55,3.55,2.85,5.27-1.11.6-6.18-11.42L135,98l2.76,5.09,6.56-3.55-2.76-5.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "141.34px 101.89px"
    },
    id: "eljrlynticscb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.41,97.3l-6,2.8.17,3.75-1.19.55-.54-14.07,1.12-.52,10.42,9.47-1.2.56Zm-.89-.82L151,91.37l.36,7.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "155.62px 97.105px"
    },
    id: "elt5xa5f6yad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.54,87.23c1,2.57,0,4.8-2.87,5.92l-3,1.19,1.53,3.81-1.17.46-4.83-12,4.14-1.66C165.18,83.78,167.51,84.65,168.54,87.23Zm-1.17.47c-.77-1.93-2.38-2.56-4.59-1.68l-2.94,1.17,2.41,6,2.94-1.17C167.4,91.16,168.13,89.59,167.37,87.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "163.559px 91.5243px"
    },
    id: "el1h2xujkp9nl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.19,83.22c.89,2.62-.32,4.79-3.19,5.77l-3,1,1.32,3.88-1.2.41L169.93,82l4.23-1.43C177,79.6,179.3,80.59,180.19,83.22Zm-1.19.41c-.66-2-2.24-2.69-4.5-1.93l-3,1,2.08,6.15,3-1C178.84,87.09,179.66,85.56,179,83.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "175.204px 87.2425px"
    },
    id: "elr1rqsivvdhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,85.16l1.21,4.32-1.19.34L186.9,85.5,180,78.62l1.3-.37,5.9,5.91,2-8.12,1.21-.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.205px 82.76px"
    },
    id: "el3vhrgr031fu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.17,84.77,208.85,78l-2,6.07-1.47.28-4-4.75,1.26,6.57-3.06.58L197.18,74l2.73-.52,5.51,6.58L208,72l2.73-.52,2.45,12.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "205.18px 79.115px"
    },
    id: "elcm28f0rt4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,77.51a6.62,6.62,0,1,1,7.33,6A6.49,6.49,0,0,1,214,77.51Zm9.77-1.1c-.25-2.23-1.82-3.53-3.61-3.33s-3,1.82-2.78,4,1.82,3.53,3.61,3.33S224,78.64,223.78,76.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "220.595px 76.9387px"
    },
    id: "eln67xl0w6lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.33,72.25l-3.65.19-.14-2.91L238.19,69l.14,2.91-3.63.18.49,10.06-3.36.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "232.935px 75.66px"
    },
    id: "ellhbkv5xsov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.43,69.12l-.19,13-3.37,0,.07-5.07-4.59-.06L243.28,82l-3.37,0,.18-13,3.37.05-.07,4.88L248,74l.07-4.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "245.67px 75.56px"
    },
    id: "elbxwoag0e92i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.16,80.19,262.93,83l-9.53-.77,1-12.94,9.31.75-.22,2.83-6-.48-.18,2.18,5.28.43-.22,2.73-5.28-.42L257,79.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "258.555px 76.145px"
    },
    id: "el9xx4oux8ls8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,80.53l-1.82-.26-.5,3.41-3.33-.48,1.86-12.86,5.39.79c3.22.46,5,2.57,4.55,5.51a4.36,4.36,0,0,1-2.9,3.73l2,4.41-3.57-.52Zm1-6.57-1.86-.27-.54,3.77,1.85.27c1.38.2,2.17-.4,2.34-1.58S272.63,74.16,271.25,74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "270.544px 77.56px"
    },
    id: "el9r2j8jup318",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.82,72.28l2.67.5-1.23,5.28L278,77.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "279.745px 75.17px"
    },
    id: "el8gktgkv34yp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,84.52,282,82.13a7,7,0,0,0,3.54,2.14c1.36.31,2,0,2.12-.59.47-2-6.47-2.07-5.38-6.77.53-2.26,2.64-3.71,6.09-2.91a8.35,8.35,0,0,1,4,2.08l-1.63,2.42a6.55,6.55,0,0,0-3-1.72c-1.38-.32-2,.07-2.14.7-.45,1.93,6.47,2,5.39,6.67-.51,2.21-2.64,3.7-6.09,2.9A8.82,8.82,0,0,1,280.26,84.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "286.315px 80.5233px"
    },
    id: "elkvkm6hn8i7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.09,77.31l5.35,1.77c3.75,1.24,5.54,4.47,4.29,8.25s-4.6,5.32-8.35,4.08L296,89.64Zm2.08,11.28a3.57,3.57,0,0,0,2.23-6.77l-2-.67-2.23,6.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "303.063px 84.5705px"
    },
    id: "elbnm4rbbtoao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.32,94.68l-4.67-1.9-1.81,2-3.19-1.3,9.77-10,3.07,1.25v14l-3.25-1.32Zm.11-2.88.14-4.43-3,3.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.07px 91.105px"
    },
    id: "el1eqoq9v09kn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.25,97.3l-2,4.2-3-1.44,2-4.26-.54-9.42,3.21,1.52.33,5.88L333,90.33l2.94,1.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.595px 93.94px"
    },
    id: "elms3gr3d2j8q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-31",
    className: "animable",
    style: {
      transformOrigin: "252.675px 268.281px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,268.12c-7.29-4.63-15.51-11.08-14.49-19.59.88-7.29,8.37-12.29,10.26-19.39,2.5-9.42-5.34-18-9.52-26.73-4.52-9.47-4.85-20.32-4.55-30.8s4.67-30.44,2.22-40.62-8.39-26.26-21.42-21.8l-.22,5c-30.6,24.38-48.7,63.22-47.41,101.74.46,13.63,3.27,27.33,9.68,39.39S216.13,277.73,228.9,283c.61-2,1.23-4,1.85-6a28.24,28.24,0,0,0,19.36,8.4l-4.26-8a19.29,19.29,0,0,0,20.43,2.68,8.87,8.87,0,0,1-4.56-5.62A11.1,11.1,0,0,0,275,268.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.403px 196.913px"
    },
    id: "ell5pu2lu1km",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,125.24l-1.73-4.63c-9.52-3.21-20.49.23-27.8,7.13s-11.28,16.76-12.74,26.7-.61,20.07.48,30.06,2.42,20,1.9,30.05c-.17,3.33-.51,6.84.92,9.86s4.76,5.2,8.16,6.05a33.88,33.88,0,0,0,10.45.45c11.54-.75,23-2,34.53-3.23,1.49-.16,3.15-.42,4.07-1.6a5.63,5.63,0,0,0,.77-3.49A264.24,264.24,0,0,0,292.63,125.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.627px 175.26px"
    },
    id: "elewk5ktu0pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.46,159.92c-1.41-13.14,10.38-28.52,23.57-29.37l43.38.82,1.06,7,12.2,87.05h0s1.17,28.56-22.68,31c-21.42,2.18-24.08-20.39-24.08-20.4l-2.14-16.44s-17.23,2.24-24.37-18.85C257.85,190.26,256,174.52,254.46,159.92Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "294.512px 193.559px"
    },
    id: "elo0f5tcwnw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,177.21c.41.31,2.25-1.61,5.24-2.11s5.44.61,5.7.19c.14-.19-.33-.78-1.4-1.31a7.65,7.65,0,0,0-4.64-.61,7.41,7.41,0,0,0-4.09,2.14C260.59,176.37,260.39,177.08,260.58,177.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.029px 175.245px"
    },
    id: "ele1yf3gbq4wv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.64,173.69c.41.3,2.25-1.61,5.24-2.12s5.44.62,5.7.2c.13-.19-.33-.78-1.4-1.32a7.73,7.73,0,0,0-4.64-.6,7.41,7.41,0,0,0-4.1,2.14C288.65,172.85,288.45,173.56,288.64,173.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.087px 171.724px"
    },
    id: "elgiloozr7x14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.56,189.81c0-.14-1.92-.11-5,.06-.78.06-1.52,0-1.73-.37s-.07-1.19.17-2q.64-2.52,1.37-5.29c.53-1.93,2.9-12.72,2.77-13.7-.35,0-2.16,6-4,13.52q-.66,2.78-1.28,5.31a3.32,3.32,0,0,0,.06,2.6,1.94,1.94,0,0,0,1.43.74,6.76,6.76,0,0,0,1.32-.06C280.69,190.26,282.58,190,282.56,189.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "278.592px 179.6px"
    },
    id: "elsyj0v4uq2f8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,219.74a55.92,55.92,0,0,0,27.7-12.7s-4.83,16.4-26.86,18.08Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "299.5px 216.08px"
    },
    id: "eldiimxby5307",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.58,188.55c-.49.06.06,3.3-2.33,6.08s-5.9,3-5.85,3.47c0,.21.88.5,2.35.29a8.16,8.16,0,0,0,4.91-2.71,7.14,7.14,0,0,0,1.75-5.06C292.3,189.24,291.8,188.49,291.58,188.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.909px 193.505px"
    },
    id: "elc76ar0zpbyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,158.65c.5.87,3-.26,6.11-.58s5.89.13,6.07-.81c.07-.45-.59-1.21-1.81-1.85a8.68,8.68,0,0,0-4.89-.87,7.82,7.82,0,0,0-4.39,1.93C288.16,157.36,287.8,158.24,288,158.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.066px 156.728px"
    },
    id: "el59mcsfig1ra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,162.8c.64.76,2.74-.3,5.37-.59s4.9.08,5.33-.82c.19-.43-.24-1.21-1.29-1.89a7.08,7.08,0,0,0-8.62,1.14C258.33,161.56,258.11,162.43,258.39,162.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.704px 160.8px"
    },
    id: "ely36cp7cf1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,177.22a13.2,13.2,0,0,0-7.37.28,6,6,0,0,0-2.61,1.53,3,3,0,0,0-.77,2.81c.46,1.47,2.19,2.1,3.72,2.3a16.71,16.71,0,0,0,8.48-1.08,3.72,3.72,0,0,0,1.48-1,2.43,2.43,0,0,0,.32-3c-.42-.8-1.83-1.47-3.25-1.87",
    style: {
      fill: "rgb(255, 171, 133)",
      transformOrigin: "297.295px 180.555px"
    },
    id: "elh44fc9r02y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,182.74a6.46,6.46,0,0,0-5.1,0,3.63,3.63,0,0,0-1.75,1.41,3.71,3.71,0,0,0-.42,2.77,3.47,3.47,0,0,0,2.67,2.44,8.14,8.14,0,0,0,5.85-.73,2.45,2.45,0,0,0,1-.92,3.14,3.14,0,0,0,.1-2.95,4.46,4.46,0,0,0-2.33-2",
    style: {
      fill: "rgb(255, 171, 133)",
      transformOrigin: "264.138px 185.911px"
    },
    id: "eln0z0d41fdpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,164.08a1.83,1.83,0,0,1-.2-.43,8.67,8.67,0,0,1-.43-1.29,26.63,26.63,0,0,1-.77-4.94,52.11,52.11,0,0,1,0-7.4,35.5,35.5,0,0,1,1.63-8.92,32,32,0,0,1,4-8.14,33.21,33.21,0,0,1,4.89-5.57,36.36,36.36,0,0,1,3.89-3.12c.48-.34.86-.59,1.13-.75a1.63,1.63,0,0,1,.41-.23,13.21,13.21,0,0,1-1.42,1.14,47.47,47.47,0,0,0-3.76,3.23,35.16,35.16,0,0,0-4.75,5.57,33.52,33.52,0,0,0-3.92,8,36.74,36.74,0,0,0-1.64,8.8,54.4,54.4,0,0,0-.12,7.34,30.32,30.32,0,0,0,.6,4.91C254.35,163.46,254.61,164.06,254.55,164.08Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.059px 143.685px"
    },
    id: "elo12ddnxlqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.92,234.46c-1.4.94-22.29,12.83-38.47,29.9L160.23,325l22.51,68.5-7.82,30.73s44.91,6.08,74.66,7.45c31.78,1.45,69.86-4.14,69.86-4.14S284.33,283.58,275,258.75s-48.75-23.11-48.75-23.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "227.945px 333.19px"
    },
    id: "el18ffcddp9xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv1yb8qxbbj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "237.455px 331.79px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.21,377.78c-.54-15.44-1.09-30.94-3.82-46.15s-7.73-30.22-16.5-42.93c-2.16-3.13-4.65-6.2-8.06-7.88-4.3-2.12-9.36-1.73-14.12-1.17-9.25,1.07-18.48,2.56-27.8,2.73s-18.82-1-27.21-5.09l-6,.22c2.83,6.72,8.1,12.1,13.77,16.67s11.86,8.49,17.35,13.28c4.3,3.77,8.45,8.22,14,9.59,5.28,1.29,10.82-.5,15.71-2.88s9.54-5.39,14.79-6.78c3.47,14.08,10.93,27.23,12,41.68,1,13.1-6,24.81-10.28,37.22l19.87-9.18c1.73-.43,1.55,2.66,2.57,1.18S289.27,379.43,289.21,377.78Z",
    id: "elmh5m0wtx3v",
    className: "animable",
    style: {
      transformOrigin: "237.455px 331.79px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,322.38a1.78,1.78,0,0,1,.2.46l.48,1.35c.21.59.45,1.31.67,2.17s.53,1.81.74,2.91.49,2.28.67,3.58.34,2.68.49,4.15a63.74,63.74,0,0,1,0,9.57,64.74,64.74,0,0,1-1.6,9.45c-.4,1.41-.75,2.77-1.19,4s-.85,2.39-1.27,3.42-.85,1.94-1.22,2.74a21.79,21.79,0,0,1-1,2l-.7,1.25a2.56,2.56,0,0,1-.27.42,1.79,1.79,0,0,1,.18-.47l.61-1.29c.28-.55.61-1.24.95-2.05s.77-1.71,1.14-2.76.82-2.16,1.2-3.41.75-2.58,1.13-4a66.83,66.83,0,0,0,1.55-9.37,65.81,65.81,0,0,0,.06-9.5c-.13-1.45-.23-2.84-.44-4.12s-.39-2.48-.6-3.57-.46-2-.66-2.91-.4-1.59-.58-2.18-.28-1-.39-1.37A2.46,2.46,0,0,1,242.16,322.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.875px 346.115px"
    },
    id: "elo6vp6e3wee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,233.93c3-5.49,6.92-11.12,6.26-17.34-.3-2.75-1.49-5.39-1.4-8.15.24-7.13,8.57-11.57,10-18.56,1.76-8.78-8-18-3.67-25.85,2.08-3.76,6.63-5.31,9.75-8.27,7.94-7.52,2.6-22.88,22-38.56l5.21,34.93a900,900,0,0,0,.13,92.19c-16.48,2.42-35.86,11.17-49.67,35.58C121.36,275,123.65,239.42,126.64,233.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.056px 198.55px"
    },
    id: "eln5vpmitwpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,104.66c-8.4-4.78-18.63-5.62-28.14-3.89s-18.41,5.87-26.86,10.57c-4.74,2.64-9.47,5.54-12.91,9.73-6.29,7.64-7.32,18.19-8.08,28.06-.62,8-1.17,16.34,2.08,23.65A24.61,24.61,0,0,0,176,186.45l73.18-61.37A33.3,33.3,0,0,0,233.58,104.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.149px 143.196px"
    },
    id: "el1rmklwshvl5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,148.71c-.76-15.74-10.89-35.19-26.58-33.76l-36.41,8.62c-11.68,2.77-19.6,12.46-20.65,24.42-.06.59-.1-.14-.1.31l1,95a28.35,28.35,0,0,0,28.49,28h0a28.36,28.36,0,0,0,28.22-27.83c.15-7.65.31-16.67.31-16.63s20.14-3,24.69-29.19C254.38,184.65,254,166.2,253.15,148.71Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "211.612px 193.088px"
    },
    id: "elqbhhs5gsedl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.27,139.9c-.05.16,3.3,1.19,7.57,1.69s7.77.3,7.76.13-3.46-.26-7.68-.77S217.31,139.71,217.27,139.9Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "224.935px 140.888px"
    },
    id: "el2ho200e3tx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,139.06c0,.17,2,.77,4.7,1s4.81-.11,4.8-.28-2.14-.18-4.75-.37S223.18,138.88,223.14,139.06Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "227.89px 139.573px"
    },
    id: "el0qx0hdn9ig6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.34,190.78c.17,0,.41-1.05,1.49-1.7s2.11-.48,2.16-.65-.22-.26-.7-.33a2.68,2.68,0,0,0-1.81.44,2.77,2.77,0,0,0-1.16,1.46C211.19,190.47,211.26,190.77,211.34,190.78Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "213.122px 189.431px"
    },
    id: "elsmbu8h7w8io",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.33,170.12a3.35,3.35,0,0,1-3.29,3.34,3.21,3.21,0,0,1-3.42-3.08,3.37,3.37,0,0,1,3.29-3.35A3.22,3.22,0,0,1,247.33,170.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.975px 170.245px"
    },
    id: "eldzms3ymuekn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,159.77c-.43.43-2.94-1.5-6.56-1.54s-6.3,1.73-6.68,1.28c-.19-.2.24-1,1.41-1.81a9.25,9.25,0,0,1,5.36-1.57,8.93,8.93,0,0,1,5.21,1.77C248.19,158.77,248.56,159.57,248.35,159.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.736px 157.98px"
    },
    id: "elar1cbl8spbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,168.89a3.37,3.37,0,0,1-3.29,3.35,3.22,3.22,0,0,1-3.42-3.09,3.36,3.36,0,0,1,3.29-3.34A3.21,3.21,0,0,1,214.6,168.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.245px 169.025px"
    },
    id: "elb5uoo9y52qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,159.91c-.43.43-2.95-1.49-6.57-1.53s-6.29,1.72-6.68,1.27c-.19-.2.25-1,1.42-1.81a9.25,9.25,0,0,1,5.36-1.56,8.86,8.86,0,0,1,5.21,1.77C214.78,158.92,215.14,159.72,214.94,159.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.32px 158.125px"
    },
    id: "el7c9obyl27i2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,186.94c0-.21,2.24-.57,5.89-1,.92-.08,1.8-.25,2-.88a4.77,4.77,0,0,0-.58-2.74c-.84-2.25-1.71-4.61-2.63-7.08-3.64-10.07-6.27-18.35-5.86-18.49s3.69,7.9,7.34,18q1.31,3.72,2.51,7.11c.33,1.06.92,2.26.42,3.63a2.3,2.3,0,0,1-1.54,1.33,6.3,6.3,0,0,1-1.57.2C227.79,187.16,225.52,187.14,225.51,186.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.541px 171.929px"
    },
    id: "eldrbffunu6k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.81,216.92S201,235.07,227.3,233l.12-6.16A66.11,66.11,0,0,1,192.81,216.92Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "210.115px 225.042px"
    },
    id: "eldlibrr7i7e5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,195.63a6.53,6.53,0,0,0-5.81-2.51,6,6,0,0,0-4.14,2.15,3.74,3.74,0,0,0-.35,4.3c.95,1.39,3,1.74,4.72,1.27a13.42,13.42,0,0,0,4.66-2.69,3.75,3.75,0,0,0,1-1.05,1.23,1.23,0,0,0,0-1.35",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "218.581px 197.063px"
    },
    id: "el8di05nvgrfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82,189.28c.59,0,.54,3.9,3.86,6.74s7.51,2.47,7.53,3c0,.24-1,.74-2.71.77a9.77,9.77,0,0,1-6.29-2.3,8.48,8.48,0,0,1-3-5.65C214.1,190.22,214.55,189.25,214.82,189.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.202px 194.535px"
    },
    id: "eljxb1hdbgnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.58,148c-.37,1-4,.45-8.23.9s-7.7,1.56-8.25.67c-.25-.43.36-1.35,1.76-2.28a14.39,14.39,0,0,1,12.56-1.2C216,146.74,216.74,147.52,216.58,148Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.323px 147.54px"
    },
    id: "el0a5dm5akfbqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.17,149.27c-.64.82-3.12-.07-6.12-.16s-5.54.47-6.12-.4c-.24-.42.17-1.23,1.29-2a8.86,8.86,0,0,1,9.86.46C247.13,148,247.46,148.88,247.17,149.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.067px 147.522px"
    },
    id: "elmj74zle6wmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,167.89c-.27-.76-13.86-5.93-14.29,8.6-.41,14.12,13.88,11.58,13.92,11.18S171.86,167.89,171.86,167.89Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "164.711px 177.24px"
    },
    id: "elu6voewzdv2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.27,182.2c-.06,0-.25.17-.67.35a2.51,2.51,0,0,1-1.84,0c-1.47-.59-2.67-3-2.67-5.54a8.19,8.19,0,0,1,.78-3.5,2.87,2.87,0,0,1,1.9-1.84,1.26,1.26,0,0,1,1.44.71c.18.4.08.68.15.71s.31-.23.21-.81a1.51,1.51,0,0,0-.53-.9,1.84,1.84,0,0,0-1.35-.4,3.47,3.47,0,0,0-2.63,2.12,8.37,8.37,0,0,0-.95,3.91c0,2.85,1.4,5.55,3.42,6.2a2.65,2.65,0,0,0,2.26-.32C167.24,182.54,167.32,182.23,167.27,182.2Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "164.196px 177.151px"
    },
    id: "el5zjqjmakj83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.41,110.82a56.47,56.47,0,0,0-74.48,49.88l5.62,4.83a14.06,14.06,0,0,0,18.77-2.16c4.69-5.75,4.29-14.76,9.78-19.75,3-2.74,7.19-3.67,11.14-4.69,7.12-1.83,14.25-4.35,19.94-9S238,118.16,237.41,110.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.198px 137.999px"
    },
    id: "el6vj6zi69ew7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.05,177.38a12,12,0,0,0-7.47-1.54,6,6,0,0,0-3,1.13,3.82,3.82,0,0,0-1.46,3.1c.09,1.83,1.68,3,3.16,3.62a15,15,0,0,0,8.79.89,3.77,3.77,0,0,0,1.73-.78,3.2,3.2,0,0,0,1.06-3.4c-.23-1.05-1.48-2.19-2.81-3",
    style: {
      fill: "rgb(255, 171, 133)",
      transformOrigin: "205.555px 180.313px"
    },
    id: "el4kt6jyj886q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.47,257.57c2.94-4.62,5.46-10,4.37-15.41-1.27-6.28-7-10.48-12.08-14.34s-10.47-8.84-10.5-15.24c0-8.34,9.14-15.48,6.89-23.51-1.11-4-4.84-6.84-5.79-10.85-1.23-5.24,2.61-10.2,6.28-14.14s7.71-8.62,7-14l-22.8,1c3.5,28.88-5,57.8-5.71,86.88-.19,8.39.25,16.95-2.09,25-1.46,5-4,9.77-4.52,15-.91,8.84,4.21,17.39,11,23.15,3.28,2.81,7.47,5.23,11.7,4.41s7.15-4.54,8.32-8.57.79-8.31.35-12.48-.92-8.42,0-12.51C189,266.66,192.53,262.19,195.47,257.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "178.257px 227.881px"
    },
    id: "el44zrsqsmqid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,168.48a1,1,0,0,1-.13-.22c-.08-.16-.2-.38-.33-.69a9,9,0,0,1-.63-2.84,11.79,11.79,0,0,1,.73-4.55A15.13,15.13,0,0,1,163.2,155a22.66,22.66,0,0,1,6.05-4.25,81.85,81.85,0,0,1,7.82-3.25,174.9,174.9,0,0,0,17.64-7.88,172.5,172.5,0,0,0,16.67-9.78A101.49,101.49,0,0,0,224,120.37a28.54,28.54,0,0,0,6.46-8.34,20.58,20.58,0,0,0,1.08-2.67l.23-.72a1.13,1.13,0,0,1,.1-.24,15.2,15.2,0,0,1-1.23,3.72,27.71,27.71,0,0,1-6.39,8.52,98.87,98.87,0,0,1-12.57,9.62A167.13,167.13,0,0,1,195,140.1,169.05,169.05,0,0,1,177.24,148a82.26,82.26,0,0,0-7.79,3.19,22.31,22.31,0,0,0-6,4.12,14.79,14.79,0,0,0-3.25,5,11.82,11.82,0,0,0-.8,4.44A10.49,10.49,0,0,0,160.31,168.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "195.541px 138.44px"
    },
    id: "elgs872pdttwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,241.08a4.09,4.09,0,0,1-.35-.32,8.73,8.73,0,0,1-.92-1,11.38,11.38,0,0,1-2-5,17.68,17.68,0,0,1,.86-8.41c1-3.16,2.92-6.46,4.81-10.14a53.48,53.48,0,0,0,4.52-12.73,112,112,0,0,0,2.16-15.41c.46-5.47.73-11.24,1.45-17.19a74.86,74.86,0,0,1,4.26-18,36.89,36.89,0,0,1,10.53-15.15,47.22,47.22,0,0,1,15.22-8.08c5.23-1.78,10.34-2.91,15.08-4.08a117.68,117.68,0,0,0,13-3.78,48.28,48.28,0,0,0,10-5,34,34,0,0,0,6.43-5.43,27.35,27.35,0,0,0,3.21-4.25c.33-.51.53-.93.69-1.2l.25-.41s-.06.15-.2.43-.34.71-.65,1.23a26.57,26.57,0,0,1-3.15,4.34A34.08,34.08,0,0,1,218.6,117a49.08,49.08,0,0,1-10,5.06,119.53,119.53,0,0,1-13,3.85c-4.75,1.18-9.85,2.33-15,4.11a46.88,46.88,0,0,0-15.06,8,36.56,36.56,0,0,0-10.36,15,74.24,74.24,0,0,0-4.24,17.9c-.73,5.92-1,11.69-1.49,17.17a111,111,0,0,1-2.21,15.46,53.57,53.57,0,0,1-4.61,12.81c-1.93,3.69-3.82,6.94-4.87,10.07a17.65,17.65,0,0,0-.93,8.28,11.56,11.56,0,0,0,1.86,4.93C139.29,240.64,139.8,241.05,139.77,241.08Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "182.649px 173.29px"
    },
    id: "el8u57b252113",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.68,346.41l-28.88,3.92c0,.32-49,6.61-48.94,5.79l3.05,14.82-41.49,19.43,22.52,9.25,30.36,30.2s46.77-13.46,58.88-32.64S370.68,346.41,370.68,346.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "313.73px 388.115px"
    },
    id: "elhbrb06ni0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,221.11a71,71,0,0,1,17-1.38c8.92.35,17.28,3.15,23.08,8.62,8.38,7.91,11.6,20.42,15.35,33,3.32,11.18,9.94,41.43,9.94,41.43l10.21,47.52s-.72,11.72-4.25,14.6-36.27,10.92-45.62,10.92-36.58,6.4-40.1,3.52-1.92-34.92-2.89-39.72-16.33-65.35-16.33-65.35l13.42-41.12Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "316.845px 299.88px"
    },
    id: "elcv59f1h54hu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,252.26l-23-14.28-1.61-12.44c-.15-1.15-2-4.61-3.69-4.39s-4.91-.33-5.51,4l-9.8,1.07s-4,2.27-3.83,5a17.23,17.23,0,0,0-2.73,6,41.21,41.21,0,0,1-2,6.89,3.83,3.83,0,0,0-.91,5c1.74,2.89,6.37,4.05,6.37,4.05l10.3,1.39L188,275.45Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "171.972px 248.295px"
    },
    id: "ele9g2kmwty34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,223.82c-8.41-8.7-28,6.35-28,6.35l-37.89,31.41c-3.34-.89-7.56,1.95-7.56,1.95L194.33,245.4c-8.58,6.81-18.17,25.91-18.17,25.91s45.39,33.09,55.06,33.48,21.69-7.36,43.74-17.73c21.16-10,29.19-25.48,29.67-27.71S310.41,232.53,302,223.82Z",
    style: {
      fill: "rgb(50, 147, 196)",
      transformOrigin: "241.439px 262.958px"
    },
    id: "eln7jn9foaq7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,223.25a16.82,16.82,0,0,1,8.42.64,14.71,14.71,0,0,1,5.19,3.19,19.83,19.83,0,0,1,4.29,6,32.4,32.4,0,0,1,2.55,8.08,35.18,35.18,0,0,1,.53,9.36,26.3,26.3,0,0,1-.92,4.89,29.7,29.7,0,0,1-1.92,4.75,38.29,38.29,0,0,1-2.71,4.35,49.36,49.36,0,0,1-3.15,3.83,72.42,72.42,0,0,1-6.79,6.44,134.41,134.41,0,0,1-12.79,9.3c-3.79,2.44-6.95,4.26-9.16,5.45-1.12.59-2,1-2.58,1.33l-.68.33-.24.1a1,1,0,0,1,.22-.15l.65-.37,2.53-1.41c2.18-1.25,5.3-3.12,9.06-5.59a138.14,138.14,0,0,0,12.68-9.36,71.66,71.66,0,0,0,6.72-6.42,48.76,48.76,0,0,0,3.12-3.79,37,37,0,0,0,2.65-4.28,29,29,0,0,0,1.89-4.66,26.8,26.8,0,0,0,.92-4.79,35.46,35.46,0,0,0-.5-9.22c-1-5.81-3.37-10.85-6.62-13.92a14.66,14.66,0,0,0-5-3.18,16.18,16.18,0,0,0-4.43-.94,14,14,0,0,0-1.66-.05,8.92,8.92,0,0,0-1.22,0l-.76,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "286.562px 257.137px"
    },
    id: "el8dcohpinnrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elye56wvv64ze"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "282.5px 279.07px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266,291.3l.47-.12A49.51,49.51,0,0,0,299,266.84,149.59,149.59,0,0,1,266,291.3Z",
    id: "el8n26vj4byz",
    className: "animable",
    style: {
      transformOrigin: "282.5px 279.07px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188,365.34h0s-18.08-71.15-39-94c-4.11-4.49-8.33-7.12-12.55-7,0,0-10.18,6.54-13.68,24.06-1.46,7.27-1.76,16.42.29,27.78,4.87,27,18.19,94.42,38.53,103.69S270.38,436.3,270.38,436.3l3.93-38.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.954px 350.318px"
    },
    id: "elx4e66kliupg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.92,313.6s.09.3.24.89.36,1.48.64,2.64c.58,2.33,1.42,5.76,2.5,10.21,2.21,8.89,5.44,21.84,9.86,38l-.11-.12,86.34,32.45.18.07,0,.19c-1.25,12.32-2.56,25.18-3.91,38.44l0,.25-.25,0c-10.21-.85-20.92-1.88-31.8-3-14.84-1.59-29.32-3.36-43.23-5.54-7-1.11-13.77-2.3-20.39-3.8-3.3-.75-6.55-1.59-9.71-2.64-.78-.28-1.58-.51-2.34-.85a14.38,14.38,0,0,1-2.25-1.05l-1.09-.6-1-.73c-.32-.25-.67-.48-1-.75l-.9-.83c-4.73-4.54-7.81-10.21-10.51-15.69a154.75,154.75,0,0,1-6.68-16.54c-3.75-10.89-6.5-21.27-8.8-30.77s-4.08-18.18-5.57-25.81c-.74-3.82-1.39-7.37-2-10.65s-1-6.29-1.27-9a72.24,72.24,0,0,1-.12-12.59,41.39,41.39,0,0,1,.53-4.37s0,.38-.13,1.11-.2,1.83-.3,3.26a75.23,75.23,0,0,0,.22,12.57c.26,2.72.69,5.73,1.31,9s1.27,6.82,2,10.63c1.51,7.62,3.32,16.28,5.64,25.78s5.09,19.86,8.85,30.72a154.29,154.29,0,0,0,6.68,16.48c2.69,5.46,5.77,11.09,10.43,15.54l.88.81c.3.27.64.48,1,.73l1,.72,1.06.58a15.19,15.19,0,0,0,2.2,1c.75.33,1.54.56,2.32.84,3.13,1,6.37,1.87,9.67,2.62,6.59,1.48,13.4,2.67,20.35,3.78,13.9,2.17,28.37,3.93,43.21,5.52,10.87,1.16,21.57,2.19,31.78,3.05l-.27.23c1.35-13.26,2.67-26.12,3.93-38.44l.16.25L187.93,365.5l-.08,0,0-.08c-4.38-16.14-7.56-29.1-9.71-38l-2.41-10.23c-.26-1.16-.46-2-.6-2.65S174.92,313.6,174.92,313.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.051px 364.015px"
    },
    id: "elkoctatwwybc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,376.65s18.7-2.13,20.18-.91,12.78,4.55,14.78,9.46c0,0,13.21,9.81,14.12,15.08s-.72,12.18-.72,12.18l-43.27,10.37-24.18-21.27-4.73-9.28.91-9.27s2.51-3.27,4.62.37a40.69,40.69,0,0,1,3.38,8.18l8.91,4.54-6.36-6.18-5.1-16.36s5.09-4,8.55,2.54,5.45,8.37,5.45,8.37L301,388.1l7.86-3.17s-8.22.45-9.86-.46S292.62,382.65,293.17,376.65Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "305.938px 397.59px"
    },
    id: "elxkgx67bxy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.8,382.24l33.42-21.59c4.68-11.5,3.3-25.48-.85-48,0,0,14.25,23.27,16.76,31.24,5.32,16.9,5.91,31.7-5.16,48.65-9,13.79-39.84,28.53-39.84,28.53Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "357.309px 366.86px"
    },
    id: "els7l7gg5sake",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,402.26a55.33,55.33,0,0,0,6.55-7.27c3.45-4.55,20.18-13.46,20.72-13.46s16-10.54,16-10.54,4.53,1.45,1.25,7.45-15.09,12.73-14.18,16.37,6,6.72,12.93,8.9a81.2,81.2,0,0,0,14.89,2.91s6.18-4,7.27-3.09.91,2.37,0,5.64-4.36,5.63-7.45,6.54-11.64,0-11.64,0,3.64,3.82,1.64,7.82h0a7.24,7.24,0,0,1-6.47,4h-2.26a2.93,2.93,0,0,1-1.36,3c-1.82,1.36-17.91,4.82-21.18,3.91s-26.34.12-26.34.12l3.24-31.79Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "308.446px 402.79px"
    },
    id: "el15uo0fz3ly4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.45,435.08a6.89,6.89,0,0,1-1.69-.16c-2.53-.7-18.23-.22-26.18.14l-.58,0,3.35-32.77,6.61-.54a56,56,0,0,0,6.36-7.09c3.24-4.26,19.14-13.16,21-13.63h0c.78-.29,9.91-6.42,15.86-10.47l.2-.14.23.07a4.32,4.32,0,0,1,2.48,2.38c.63,1.56.31,3.51-.94,5.79-1.53,2.81-4.76,5.67-7.89,8.43S310.6,393,311,394.68c.8,3.2,5.27,6.24,12.59,8.56a82.14,82.14,0,0,0,14.61,2.87c2.45-1.57,6.55-3.94,7.72-3,1.42,1.18,1,3.11.16,6.15-1,3.46-4.61,6-7.79,6.89-2.49.73-8.18.35-10.66.13,1,1.45,2.5,4.36,1,7.43A7.67,7.67,0,0,1,321.7,428H320a3.61,3.61,0,0,1-1.61,2.9C316.76,432.15,303.83,435.08,298.45,435.08Zm-9-1.52a42.84,42.84,0,0,1,7.59.4c3.2.89,19.05-2.55,20.75-3.83a2.48,2.48,0,0,0,1.18-2.47l-.16-.63h2.9a6.71,6.71,0,0,0,6-3.72c1.82-3.63-1.52-7.22-1.55-7.25l-.93-1,1.34.15c.09,0,8.48.89,11.45,0s6.25-3.11,7.11-6.2c.93-3.35,1-4.44.16-5.11-.52-.3-3.65,1.16-6.68,3.12l-.14.1-.18,0a83.68,83.68,0,0,1-15-2.93c-7.67-2.43-12.38-5.72-13.26-9.26-.57-2.28,2.73-5.19,6.55-8.57,2.92-2.58,6.23-5.5,7.68-8.16,1.09-2,1.39-3.66.89-4.93a3.29,3.29,0,0,0-1.65-1.72C308.14,382,307.63,382,307.44,382c-1,.31-17,8.88-20.33,13.26a55,55,0,0,1-6.61,7.34l-.12.11-6.12.5L271.12,434C273.53,433.93,282.62,433.56,289.44,433.56Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "308.425px 402.751px"
    },
    id: "el74fu8gnpoi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.49,227a8.76,8.76,0,0,0,1.06-3.8c.17-5-7.45-10.57-10.23-14.67-6.51-9.61-5.14-22.53-9.55-33.28-2.95-7.17-8.36-13.07-11.81-20-4.07-8.19-5.37-17.74-10.68-25.19a31.91,31.91,0,0,0-18.67-12.1,43.92,43.92,0,0,0-22.46,1l-.06.61a61.48,61.48,0,0,0-12.39,3.21c-4.11,1.55-8.28,5.31-8.66,10-.19,2.39.87,4.72,2.11,6.75,5.77,9.46,16.34,15.43,26.83,15.16,2.39-.07,4.9-.41,7.09.69,2.68,1.33,4.65,4,6.06,6.83a30,30,0,0,1,1.35,3.94c1,3.85,1.39,7.92,3.1,11.52,2.13,4.47,7.1,7.45,8.06,12.31,1.53,7.76-5.52,9.58-9.57,16.37a24.52,24.52,0,0,0-2.46,7c-2.8,10.54-.83,27,7.14,37.09a6.79,6.79,0,0,0,8.59,1.71c2.37-1.29,4.84-2.56,7.37-3.84,4.1-2.39,7.58-3.22,10.74-5.46,6.6-3.47,16.31-5.39,21.43-9.83a19.17,19.17,0,0,0,5.45-5.66l.22-.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.285px 184.975px"
    },
    id: "el5udbx3l1zju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.65,231.64a1.9,1.9,0,0,1,.08-.35c.06-.26.15-.59.26-1,.24-.9.59-2.22,1-3.93a77,77,0,0,0,2.31-14.68,42.88,42.88,0,0,0-.68-10.21,34,34,0,0,0-4.07-10.95,26.07,26.07,0,0,0-9-9.13c-1.91-1.21-3.94-2.32-5.87-3.68a16,16,0,0,1-5-5.13,17.45,17.45,0,0,1-2.06-6.87c-.27-2.35-.29-4.66-.41-6.92a29.81,29.81,0,0,0-.91-6.54,13.89,13.89,0,0,0-3-5.48c-2.75-3.09-6.45-4.78-9.89-6s-6.83-2-9.84-3c-6-1.91-10.52-4.78-12.67-7.63a13.2,13.2,0,0,1-2-3.55c-.11-.43-.21-.77-.28-1a3.51,3.51,0,0,1-.08-.35,1.54,1.54,0,0,1,.13.34c.09.25.2.58.33,1a13.64,13.64,0,0,0,2,3.46c2.17,2.77,6.63,5.56,12.62,7.41,3,.94,6.38,1.7,9.88,2.95s7.25,2.94,10.1,6.12a14.43,14.43,0,0,1,3.08,5.67,30.47,30.47,0,0,1,.94,6.65c.12,2.26.15,4.57.41,6.88a16.88,16.88,0,0,0,2,6.66,15.36,15.36,0,0,0,4.84,5c1.9,1.34,3.92,2.45,5.84,3.67a27.19,27.19,0,0,1,5.25,4.18,28,28,0,0,1,3.88,5.13,34.35,34.35,0,0,1,4.09,11.12,43,43,0,0,1,.61,10.31,73.16,73.16,0,0,1-2.47,14.71c-.45,1.71-.84,3-1.11,3.91l-.31,1A1.61,1.61,0,0,1,343.65,231.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "314.58px 178.44px"
    },
    id: "elggwgqwsb5jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,181a13.36,13.36,0,0,0-1.39-3.29,22.19,22.19,0,0,0-7.06-6.66c-1.71-1.16-3.66-2.35-5.58-3.88a20.76,20.76,0,0,1-2.77-2.64,17.83,17.83,0,0,1-2.21-3.41,39.47,39.47,0,0,1-2.61-8.24,42.6,42.6,0,0,0-2.68-8.78,14.85,14.85,0,0,0-6-6.62,27.77,27.77,0,0,0-8-3c-2.67-.61-5.25-1-7.66-1.39a49.8,49.8,0,0,1-6.64-1.52,25.36,25.36,0,0,1-5.18-2.2,16.4,16.4,0,0,1-3.39-2.57,12,12,0,0,1-1.68-2.09l-.36-.6c-.07-.14-.11-.21-.1-.22a19.19,19.19,0,0,0,2.28,2.77,17.63,17.63,0,0,0,3.39,2.46,26.38,26.38,0,0,0,5.14,2.1,51.32,51.32,0,0,0,6.61,1.45c2.41.38,5,.74,7.69,1.34a28.44,28.44,0,0,1,8.13,3,15.29,15.29,0,0,1,6.23,6.84,42.43,42.43,0,0,1,2.71,8.88,38.45,38.45,0,0,0,2.54,8.15,17.29,17.29,0,0,0,2.13,3.32,19.92,19.92,0,0,0,2.69,2.6c1.88,1.53,3.81,2.74,5.52,3.92a31.21,31.21,0,0,1,4.39,3.52,15.3,15.3,0,0,1,2.63,3.34,10.06,10.06,0,0,1,1,2.47,6,6,0,0,1,.15.68A.74.74,0,0,1,350.15,181Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "318.494px 152.445px"
    },
    id: "el17lg6vflb98",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandMother);
export default __webpack_public_path__ + "static/media/LandMother.c13b815d9c68d3e26e880d3c78caaa6e.svg";
export { ForwardRef as ReactComponent };